<script setup>
    import Dialog from 'primevue/dialog';
    import Button from 'primevue/button';
    import { ref, defineProps, defineEmits, computed } from 'vue';

    const visible = ref(true);

    const props = defineProps(['mode', 'message']);
    const emit = defineEmits(['confirm', 'cancel']);

    const headerText = computed(() => {
        if (props.mode === 'ERROR') return 'Ошибка!';
        if (props.mode === 'WARNING') return 'Предупрежедние!';
        return 'Сообщение';
    });

    const iconColor = computed(() => {
        if (props.mode === 'ERROR') return 'red';
        if (props.mode === 'WARNING') return 'orange';
        return '';
    });

    const iconName = computed(() => {
        if (props.mode === 'ERROR') return 'pi pi-times-circle';
        if (props.mode === 'WARNING') return 'pi pi-exclamation-triangle';
        return 'pi pi-exclamation-circle';
    });
</script>

<template>
    <Dialog v-model:visible="visible" modal :header="headerText" style="max-width: 70%" @hide="emit('confirm')">
        <div class="p-dialog-content pt-3" style="min-width: 25rem;">
            <div class="flex">
                <div class="flex align-items-center justify-content-center m-1">
                    <i :class="iconName" style="font-size: 4rem;" :style="{ 'color' : iconColor}" ></i>
                </div>
                <div class="flex align-items-center justify-content-centerm-2 px-5 py-2">
                    {{ message }}
                </div>
            </div>
        </div>

        <div class="p-dialog-footer pb-0" style="text-align: center;">
            <Button @click="emit('confirm')" autofocus >Закрыть</Button>
        </div>
    </Dialog>
</template>
